import React from 'react';
import { NEW_NDTV_SOCIAL_ICONS } from '../../../../constants';
import get from 'lodash/get';
import { connect, useSelector } from 'react-redux';
import { followIconsDl } from '../../../../helpers/datalayer-utils';
import './social-share-icon-list.m.css';

const SocialShare = ({ pageType, sectionName }) => {
  const userData = useSelector((state) => get(state, ['userData']));
  return (
    <div styleName="list">
      <nav styleName="social-icons">
        {NEW_NDTV_SOCIAL_ICONS &&
          NEW_NDTV_SOCIAL_ICONS?.map((item, index) => (
            <a
              key={index}
              styleName="icon-container"
              target="_blank"
              rel="noopener noreferrer"
              href={item.url}
              aria-label="social-icons"
              onClick={() => followIconsDl(item.name, pageType, userData, sectionName)}
            >
              <i styleName="icon" className={item.icon_code} />
            </a>
          ))}
      </nav>
    </div>
  );
};

const mapStateToProps = (state) => ({
  pageType: get(state, ['qt', 'pageType'], ''),
});

export default connect(mapStateToProps)(SocialShare);
